const settingSideBarLinks = [
  { href: "/setting/mypage", title: "마이페이지" },
  { href: "/setting/faq", title: "FAQ" },
  { href: "/setting/contact", title: "고객문의" },
  { href: "/setting/logout", title: "로그아웃" },
  { href: "/setting/delete-account", title: "회원탈퇴" },
];

export default settingSideBarLinks;
